import React from 'react';
import {Switch} from 'antd';
import commonRefHOC from '../../commonRefHOC';

export default commonRefHOC(Switch);